import { z } from 'zod';
import { SessionTenantTypeSchema } from '../auth-sso/signed-in-session.schema';
/**
 * Membership Summary Schema
 * One workspace an identity can sign into, served by the memberships list
 * endpoint. The staff sentinel membership appears as the super-admin
 * pseudo-tenant. A pending membership is an invite the user has not entered
 * yet — pickers badge it; switching into it accepts it.
 */ export const MembershipSummarySchema = z.object({
    tenantId: z.string(),
    slug: z.string(),
    name: z.string(),
    tenantType: SessionTenantTypeSchema,
    expiresAt: z.iso.datetime().nullable(),
    status: z.enum([
        'active',
        'pending'
    ])
});
/**
 * List Memberships Response Schema
 * GET /api/v2/auth/memberships
 * Sign-in-eligible memberships (active + pending); legacy sessions (no
 * identity link) get an empty list.
 */ export const ListMembershipsResponseSchema = z.object({
    memberships: z.array(MembershipSummarySchema)
});

//# sourceMappingURL=list-memberships.schema.js.map